export default {
  form: {
    errorsHeading: 'The following errors were found on the form.'
  },
  button: {
    blocked: 'There are currently errors on the form'
  },
  login: {
    success: 'Login successful, Welcome',
    failed: 'Login unsuccessful: %s',
    error: 'There was an error logging you in, please try again soon',
    buttonText: 'Sign In'
  },
  logout: {
    success: 'Logout successful, Goodbye',
    failed: 'Logout unsuccessful: %s',
    error: 'There was an error logging you out, please try again',
    buttonText: 'Logout'
  },
  autocomplete: {
    noResults: 'No results found',
    error: 'Whoops! Somethings gone wrong',
    missing: 'N/A'
  },
  calendar: {
    january: 'January',
    febuary: 'Febuary',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    sunday: 'Su',
    monday: 'Mo',
    tuesday: 'Tu',
    wednesday: 'We',
    thursday: 'Th',
    friday: 'Fr',
    saturday: 'Sa'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js